import React, { Component } from 'react';

export default class FooterComponent extends Component {
  render() {
    const { noContent } = this.props;
    return (
      <footer className="landing-footer">
        <div className="container">
          {
            !noContent &&
            <div className="row">
              <div className="col-sm-12">
                <h2 className="footer-title">So much time and effort put into SEO and advertising to get your
                  customers to simply engage.
                </h2>
                <p className="description">
                  We have created the shortcut for your users to bypass searching. All the users have to
                  do is remember the catchy wormhole you have created, and speak it into their phone.
                  <span className="highlight">that's it.</span>
                </p>
                <a href="/signup" className="btn-footer-action">Get My Wormhole</a>
              </div>
            </div>
          }
          <div className="row">
            <div className="col-sm-12">
              <ul className={`footer-links ${noContent ? 'extend' : ''}`}>
                <li><a href="">Copyright © 2018 Vocalize llc.</a></li>
                <li><a href="mailto:support@vocalizemysite.com">CONTACT US AT SUPPORT@VOCALIZEMYSITE.COM</a></li>
                <li><a href="/about">About / Press Kit.</a></li>
                <li><a href="/terms">Our Terms of Service.</a></li>
                <li><a href="/privacy-policy">Our Privacy Policy.</a></li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/landing/FooterComponent.js